module.exports = __webpack_public_path__ + "/res/logo-2b67b2b03d85be1a104039d841e3f138.svg";


//////////////////
// WEBPACK FOOTER
// ./core/src/components/LuminopiaLogo/logo.svg
// module id = 1224
// module chunks = 0